import { MakeLogicType, actions, connect, kea, listeners, path, reducers } from 'kea'
import React from 'react'

import { featureFlagLogic } from 'lib/logic/featureFlagLogic'
import { SceneConfig } from 'scenes/sceneTypes'

import type { FeatureFlagsSet } from '../../lib/logic/featureFlagLogic'
import { panelLayoutLogic } from '../panel-layout/panelLayoutLogic'

export type SceneLayoutContainerRef = React.RefObject<HTMLElement> | null

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface sceneLayoutLogicValues {
    featureFlags: FeatureFlagsSet // featureFlagLogic
    mainContentRect: DOMRect | null // panelLayoutLogic
    sceneLayoutConfig: SceneConfig | null
    scenePanelElement: HTMLElement | null
    scenePanelIsPresent: boolean
    scenePanelOpenManual: boolean
    showDescription: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface sceneLayoutLogicActions {
    registerScenePanelElement: (element: HTMLElement | null) => {
        element: HTMLElement | null
    }
    setSceneLayoutConfig: (config: SceneConfig) => {
        config: SceneConfig
    }
    setScenePanelIsPresent: (active: boolean) => {
        active: boolean
    }
    setScenePanelOpen: (open: boolean) => {
        open: boolean
    }
    toggleShowDescription: () => {
        value: true
    }
}

export type sceneLayoutLogicType = MakeLogicType<sceneLayoutLogicValues, sceneLayoutLogicActions>

export const sceneLayoutLogic = kea<sceneLayoutLogicType>([
    path(['layout', 'scene-layout', 'sceneLayoutLogic']),
    connect(() => ({
        values: [featureFlagLogic, ['featureFlags'], panelLayoutLogic, ['mainContentRect']],
    })),
    actions({
        registerScenePanelElement: (element: HTMLElement | null) => ({ element }),
        setScenePanelIsPresent: (active: boolean) => ({ active }),
        setScenePanelOpen: (open: boolean) => ({ open }),
        setSceneLayoutConfig: (config: SceneConfig) => ({ config }),
        toggleShowDescription: true,
    }),
    reducers({
        showDescription: [
            true,
            { persist: true },
            {
                toggleShowDescription: (state) => !state,
            },
        ],
        scenePanelElement: [
            null as HTMLElement | null,
            {
                registerScenePanelElement: (_, { element }) => element,
            },
        ],
        scenePanelIsPresent: [
            false,
            {
                setScenePanelIsPresent: (_, { active }) => active,
            },
        ],
        scenePanelOpenManual: [
            false,
            {
                setScenePanelOpen: (_, { open }) => open,
            },
        ],
        sceneLayoutConfig: [
            null as SceneConfig | null,
            {
                setSceneLayoutConfig: (_, { config }) => config,
            },
        ],
    }),
    listeners(({ values }) => ({
        registerScenePanelElement: () => {
            refreshScenePanelElementSelectorCache(values)
        },
    })),
])

// The memoized `scenePanelElement` selector only recomputes when evaluated, and once
// the last ScenePanel unmounts nothing subscribes to it — so without this read its
// cached result keeps the previous (now detached) panel container alive, which pins
// the departed scene's entire fiber and DOM tree via the element's React fiber expandos.
function refreshScenePanelElementSelectorCache(values: sceneLayoutLogicType['values']): void {
    void values.scenePanelElement
}
